
import { heroImages } from '../../../utils/images';

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden" style={{ height: '400px', backgroundColor: '#fff' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center" style={{ paddingTop: '40px' }}>
        <div className="w-full text-center">
          <h1 className="text-4xl lg:text-5xl font-light mb-4 leading-tight" style={{ color: '#4b5563' }}>
            Our Product Range
          </h1>
          <p className="text-lg max-w-2xl mx-auto font-light leading-relaxed" style={{ color: '#4b5563' }}>
            We focus on leather garments, shearling, PU, faux fur, down jackets, and woven outerwear, combining craftsmanship and innovation to deliver products that meet the highest international standards.
          </p>
        </div>
      </div>
    </section>
  );
}
